import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import first from 'lodash/first';
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  InputLabel,
  Grid,
} from '@mui/material';

import MultiSelect from '../../common/multi-select';
import { modalStyles } from '../../../lib/styles';

function BaseBulkAssignModal({
  open,
  handleCloseModal,
  handleSave,
  wranglerOptions,
  taskIds,
}) {
  const firstAssignedWranglerId = first(wranglerOptions).value;
  const [assignedWranglerIdValue, setAssignedWranglerId] = useState(firstAssignedWranglerId);

  const bulkUpdateTask = (event, taskIds) => {
    if (!taskIds || taskIds.length === 0) return;
    handleSave(event, taskIds, assignedWranglerIdValue);
    handleCloseModal();
  };

  if (open && taskIds.length < 1) {
    return (
      <Dialog
        open={open}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="sm"
        disableEnforceFocus
      >
        <DialogContent>
          <Typography variant="subtitle1">Please Select Scooters With Tasks</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseModal}
      fullWidth
      PaperProps={{ sx: modalStyles.dialog }}
      disableEnforceFocus
    >
      <DialogTitle>
        <Typography component="span" variant="h6">Task Details</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid item xs={12} md={6} sx={modalStyles.relative}>
          <InputLabel sx={modalStyles.label}>Assigned To</InputLabel>
          <MultiSelect
            value={[assignedWranglerIdValue]}
            options={wranglerOptions}
            isSingle
            placeholder="Select an assigned user"
            handleChange={(wranglerId) => setAssignedWranglerId(wranglerId)}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseModal} color="secondary">
          Cancel
        </Button>
        <Button onClick={(e) => bulkUpdateTask(e, taskIds)} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}

BaseBulkAssignModal.propTypes = {
  handleCloseModal: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  wranglerOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  taskIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const BulkAssignModal = withRouter(BaseBulkAssignModal);
export { BaseBulkAssignModal, BulkAssignModal };
